import { Box, Button, Checkbox, Divider, Flex, FormControl, FormErrorMessage, FormLabel, Grid, Image, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text, } from '@chakra-ui/react';
import MyDiv from './approveAllCard.style';
import SendBackIcon from '../../../../../assets/images/SendBackIcon.svg'
import AdditionalDocIcon from '../../../../../assets/images/AdditionalDocIcon.svg'
import { useEffect, useRef, useState } from 'react';
import { CustomButton, CustomToast } from '../../../../../components';
import { Dropdown } from "../../../../../components/DropDown/DropDown";
import { IApproveAll, defaultApproveAll, PayrollOption, BusinessProcess, IApproveAlProps, schema } from './modal';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useFetch, websiteUrl } from "../../../../../hooks/useFetch";
import { HrlenseInput } from '../../../../../components/Input/Input';
import Typeahead from "../../../../../components/AutoCompleteInput/Typeahead";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { MultiSelectMenu } from '../../../../../components/MultiSelectMenu/MultiSelectMenu';
import { format } from 'date-fns/format';
import { useAuth } from '../../../../../hooks/useAuth';

const ApproveAllCard = ({ candidateDetail, reload, setReload }: IApproveAlProps) => {
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const { hasPermission } = useAuth();
    const [approveChecked, setApproveChecked] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [payrollCompanyOptions, setPayrollCompanyOptions] = useState<PayrollOption[]>([]);
    const [companyOptions, setCompanyOptions] = useState<any[]>([]);
    const [branchOptions, setBranchOptions] = useState<any[]>([]);
    const [departmentOptions, setDepartmentOptions] = useState<any[]>([]);
    const [businessProcess, setBusinessProcess] = useState<BusinessProcess[]>([]);
    const [designationOptions, setDesignationOptions] = useState<any[]>([]);
    const [shiftOptions, setShiftOptions] = useState<any[]>([]);
    const [managerOptions, setManagerOptions] = useState<any[]>([]);
    const [teamLeadOptions, setTeamLeadOptions] = useState<any[]>([]);
    const managerTimeout = useRef<any>(null);
    const teamLeadTimeout = useRef<any>(null);
    const [roleOptions, setRoleOptions] = useState<any[]>([]);
    const [selectedRoles, setSelectedRoles] = useState<number[]>([]);
    const editorRef = useRef<any>(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState<"sendBack" | "requestDocs" | null>(null);
    const [verifyLoading, setVerifyLoading] = useState(false);
    const [sendEmailLoading, setSendEmailLoading] = useState(false);
    const [subject, setSubject] = useState("");
    const [emailBody, setEmailBody] = useState("");
    const [employeeBranch, setEmployeeBranch] = useState<any[]>([]);
    const [selectedBranch, setSelectedBranch] = useState<number[]>([]);


    const { handleSubmit, control, formState: { errors }, reset, watch } = useForm<IApproveAll>({
        resolver: yupResolver(schema),
        defaultValues: defaultApproveAll,
        mode: "onBlur",
    });

    const handleVerify = () => {
        if (candidateDetail?.employee_Id === 0 || candidateDetail?.employee_Id === null) {
            addToast({ message: "Candidate has not completed their details yet.", status: "info" });
            return;
        }

        if (approveChecked) {
            setAlertOpen(true);
        }
    };

    const onSubmit = async (data: IApproveAll, sendOfferLetter: boolean) => {

        if (selectedRoles.length === 0) {
            addToast({ message: "Select atleast one role", status: "warning" });
            return;
        }
        setVerifyLoading(true);
        const payload = {
            ...data,
            date_of_Joining: format(data.date_of_Joining, "yyyy-MM-dd"),
            employee_Id: candidateDetail?.employee_Id,
            manager_Id: data.manager_Id?.employeeID,
            teamLead_Id: data.teamLead_Id?.employeeID,
            role: selectedRoles,
            branch: selectedBranch
        };
        const res = await fetchApi(`OfferAndOnBoarding/Approve?sendOfferLetter=${sendOfferLetter}`, "POST", payload, null, "Posted Successfully");
        if (res) {
            setAlertOpen(false);
            reset(defaultApproveAll);
            setApproveChecked(false);
            setVerifyLoading(false);
            setReload && setReload(!reload);
        }
        setVerifyLoading(false);
    };


    const PayrollCompany = async () => {
        const response = await fetchApi("DropDown/payrollCompany", "GET", null, "", "");
        if (response) setPayrollCompanyOptions(response);
    };
    const UsCompany = async () => {
        const response = await fetchApi("DropDown/UsCompany", "GET", null, "", "");
        if (response) setCompanyOptions(response);
    };
    const loadBranchOptions = async (companyId: number) => {
        const res = await fetchApi("DropDown/branches", "GET", null, `companyId=${companyId}`, "");
        if (res) setBranchOptions(res);
        else setBranchOptions([]);
    };
    const loadDepartmentOptions = async () => {
        const res = await fetchApi("DropDown/department", "GET", null, "", "");
        if (res) setDepartmentOptions(res);
    };
    const loadBusinessProcess = async () => {
        const res = await fetchApi("DropDown/businessProcess", "GET", null, "", "");
        if (res) setBusinessProcess(res);
    };
    const loadShiftOptions = async () => {
        const res = await fetchApi("DropDown/shift", "GET", null, "", "");
        if (res) setShiftOptions(res);
    };

    const loadDesignationOptions = async (department: number) => {
        const res = await fetchApi("DropDown/designation", "GET", null, `department=${department}`, "");
        if (res) setDesignationOptions(res);
    };

    const handleManagerChange = (value?: string) => {
        if (managerTimeout.current) clearTimeout(managerTimeout.current);
        managerTimeout.current = setTimeout(async () => {
            if (value === undefined) setManagerOptions([]);
            else if (value.length > 0) {
                const res = await fetchApi("Hrlense_Employee/EmployeeList", "GET", null, `filter=${value}`, "");
                if (res) setManagerOptions(res);
            }
        }, 500);
    };
    const handleTeamLeadChange = (value?: string) => {
        if (teamLeadTimeout.current) clearTimeout(teamLeadTimeout.current);
        teamLeadTimeout.current = setTimeout(async () => {
            if (value === undefined) setTeamLeadOptions([]);
            else if (value.length > 0) {
                const res = await fetchApi("Hrlense_Employee/EmployeeList", "GET", null, `filter=${value}`, "");
                if (res) setTeamLeadOptions(res);
            }
        }, 500);
    };
    const loadRoleOptions = async () => {
        const res = await fetchApi("DropDown/role", "GET", null, "", "");
        if (res) setRoleOptions(res);
    };

    const loadCandidateJobDetail = async () => {
        const response = await fetchApi("JobOpening/candidateJobDetail", "GET", null, `jobId=${candidateDetail?.jobId}`, "");
        if (response) {
            reset(response);
        } else {
            reset();
        }
    }


    const laodEmployeeAssignedBranch = async () => {
        const response = await fetchApi("Dropdown/branchWithCompany", "GET", "", "", "");
        if (response) {
            setEmployeeBranch(response);
        }
    }
    useEffect(() => {
        PayrollCompany();
        UsCompany();
        loadDepartmentOptions();
        loadBusinessProcess();
        loadShiftOptions();
        loadRoleOptions();
        laodEmployeeAssignedBranch();
    }, []);

    useEffect(() => {
        if (alertOpen && candidateDetail?.jobId) {
            loadCandidateJobDetail();
        }
    }, [alertOpen, candidateDetail]);

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            if (name === "company_Id") {
                if (value.company_Id) loadBranchOptions(value.company_Id);
                else setBranchOptions([]);
            }
            if (name === "department_Id") {
                if (value.department_Id) loadDesignationOptions(Number(value.department_Id));
                else setDesignationOptions([]);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    const handleSendBackClick = () => {
        setModalMode("sendBack");
        setSubject("Action Required: Please Complete Your Application Details");
        setEmailBody(
            `Dear ${candidateDetail?.candidate_Name || "Candidate"},<br/><br/>
            We have reviewed your application and noticed that some required details are missing or incomplete.<br/><br/>
            Kindly log in to the portal and update the necessary information at the earliest, so that we can proceed further with your onboarding process.<br/><br/>
            <p>
                <a href="${websiteUrl || "#"}otp-verification?email=${encodeURIComponent(candidateDetail?.candidate_Email || "")}&job=${btoa(String(candidateDetail?.jobId))}" 
                    target="_blank" rel="noopener noreferrer">
                    Click here to fill your details
                </a>
            </p>
            If you face any difficulties, please feel free to reach out to our HR team.<br/><br/>

            Regards,<br/>
            HR Team`
        );
        setModalOpen(true);
    };

    const handleRequestDocsClick = () => {
        setModalMode("requestDocs");
        setSubject("Request for Additional Documents - Onboarding Process");
        setEmailBody(
            `Dear ${candidateDetail?.candidate_Name || "Candidate"},<br/><br/>
            As part of the verification process, we require some additional documents from your side.<br/><br/>
            Please provide the requested documents at the earliest to avoid any delay in the onboarding process.<br/><br/>        
            You can upload the documents directly on the portal or send them to the HR team as per instructions provided.<br/><br/>
            <p>
                <a href="${websiteUrl || "#"}otp-verification?email=${encodeURIComponent(candidateDetail?.candidate_Email || "")}&job=${btoa(String(candidateDetail?.jobId))}" 
                    target="_blank" rel="noopener noreferrer">
                    Click here to fill your details
                </a>
            </p>
            Regards,<br/>HR Team`
        );
        setModalOpen(true);
    };

    const sendCandidateEmail = async (e: React.FormEvent) => {
        e.preventDefault();
        setSendEmailLoading(true);
        let payload = {
            candidate_Id: candidateDetail.candidate_Id,
            subject,
            body: emailBody,
        };
        const res = await fetchApi("OfferAndOnBoarding/sendCandidateAdditionalMail", "POST", payload, null, "");
        if (res) {
            addToast({ message: "Request sent successfully", status: "success" });
            setModalOpen(false);
            setSubject("");
            setEmailBody("");
            setModalMode(null);
            setSendEmailLoading(false);
        }
        setSendEmailLoading(false);
    };

    useEffect(() => {
        if (candidateDetail?.department) loadDesignationOptions(candidateDetail?.department)
        if (candidateDetail?.company_Id) loadBranchOptions(candidateDetail?.company_Id)
    }, [candidateDetail])

    console.log(candidateDetail)
    return (
        <MyDiv>
            {(candidateDetail?.status_Name.toLowerCase() !== "joined" && candidateDetail?.status_Name.toLowerCase() !== "backout") && (
                <>
                    <Box className='cards' >
                        <Box pt={5} pl={5} pr={5} pb={"100px"} >
                            <Flex justify='space-between' mb={5}>
                                <Text className='font-poppins text_lg text_medium'>Approve All</Text>
                                <Checkbox colorScheme='green' isChecked={approveChecked} onChange={(e) => setApproveChecked(e.target.checked)} />
                            </Flex>
                            <Divider />
                            <Flex justify='space-between' mt={5} mb={5} opacity={candidateDetail?.status_Name?.toLowerCase() === "accepted" ? 1 : 0.5}>
                                <Text className='font-poppins text_lg text_medium'>Send Back to Candidate</Text>
                                <Image
                                    src={SendBackIcon}
                                    alt="sendBack"
                                    cursor={candidateDetail?.status_Name?.toLowerCase() === "accepted" ? "pointer" : "not-allowed"}
                                    onClick={candidateDetail?.status_Name?.toLowerCase() === "accepted" ? handleSendBackClick : undefined}
                                />
                            </Flex>

                            <Divider />

                            <Flex justify='space-between' mt={5} mb={5} opacity={candidateDetail?.status_Name?.toLowerCase() === "accepted" ? 1 : 0.5}>
                                <Text className='font-poppins text_lg text_medium'>Request Additional Docs</Text>
                                <Image
                                    src={AdditionalDocIcon}
                                    alt="additionalDocs"
                                    cursor={candidateDetail?.status_Name?.toLowerCase() === "accepted" ? "pointer" : "not-allowed"}
                                    onClick={candidateDetail?.status_Name?.toLowerCase() === "accepted" ? handleRequestDocsClick : undefined}
                                />
                            </Flex>

                            <Divider />
                        </Box>
                    </Box>
                    <Button className="font-poppins text_sm text_medium btn" w="100%" mt={6} onClick={handleVerify} disabled={!approveChecked}> Verify </Button>
                </>
            )}

            <Modal isOpen={alertOpen} onClose={() => setAlertOpen(false)} size="3xl" isCentered>
                <ModalOverlay />
                <ModalContent p={1} borderRadius="xl" as="form" >
                    <ModalHeader textAlign="center" className="font-poppins text_medium text_xl"> Verification Form</ModalHeader>
                    <ModalCloseButton />
                    <Divider />
                    <ModalBody>
                        <Grid templateColumns="repeat(2, 1fr)" gap={4} mt={4}>
                            <Dropdown isRequired name="payroll_Company_Id" label="Payroll Company" control={control} errors={errors} options={payrollCompanyOptions} valueKey="id" labelKey="payroll_Company_Name" />
                            <HrlenseInput isRequired name="email" control={control} errors={errors} label="Official Email" type="email" placeholder="Enter official Email" />
                            <Dropdown isRequired name="company_Id" label="Company" control={control} errors={errors} options={companyOptions} valueKey="id" labelKey="company_Name" />
                            <Dropdown isRequired name="branch_Id" label="Branch" control={control} errors={errors} options={branchOptions} valueKey="branch_Id" labelKey="branchName" />
                            <Dropdown isRequired name="department_Id" label="Department" control={control} errors={errors} options={departmentOptions} valueKey="id" labelKey="departmentName" />
                            <Dropdown isRequired name="designation_Id" label="Designation" control={control} errors={errors} options={designationOptions} valueKey="id" labelKey="designation" />

                            <HrlenseInput isRequired name="date_of_Joining" control={control} errors={errors} label="Date Of Joining" type="date" placeholder="Select date of Joining" />
                            <Dropdown isRequired name="business_Process_Id" label="Business Process" control={control} errors={errors} options={businessProcess} valueKey="business_Process_Id" labelKey="business_Process_Name" />
                            <Dropdown isRequired name="shift_Id" label="Shift" control={control} errors={errors} options={shiftOptions} valueKey="id" labelKey="shift" />
                            <HrlenseInput isRequired name="probation_Period" control={control} errors={errors} label="Probation Period(Month)" type="number" placeholder="Enter Probation Period" />
                            <MultiSelectMenu label="Select Role" placeholder="Select role" options={roleOptions} selectedValues={selectedRoles} setSelectedValues={setSelectedRoles} labelKey="role" valueKey="id" colorScheme="blue" />
                            {selectedRoles.length > 0 && !selectedRoles.includes(3) && (
                                <MultiSelectMenu
                                    label='Assigned Branches'
                                    ShowNumberOfTiles={1}
                                    placeholder="Select Branch"
                                    overflow={true}
                                    options={employeeBranch}
                                    selectedValues={selectedBranch}
                                    setSelectedValues={setSelectedBranch}
                                    labelKey="branchName"
                                    valueKey="branchId"
                                    colorScheme="green"
                                />
                            )}

                            <FormControl isInvalid={!!errors.manager_Id}>
                                <FormLabel>Manager</FormLabel>
                                <Typeahead name="manager_Id" control={control} placeholder="Select Manager..." loading={loading}
                                    onCompletion={(query) => handleManagerChange(query)} options={managerOptions}
                                    optionLabel="emp_Name" optionValue="employeeID"
                                />
                                <FormErrorMessage>{errors.manager_Id?.message}</FormErrorMessage>
                            </FormControl>
                            <FormControl isInvalid={!!errors.teamLead_Id}>
                                <FormLabel>Team Lead</FormLabel>
                                <Typeahead name="teamLead_Id" control={control} placeholder="Select Team Lead..." loading={loading}
                                    onCompletion={(query) => handleTeamLeadChange(query)} options={teamLeadOptions}
                                    optionLabel="emp_Name" optionValue="employeeID"
                                />
                                <FormErrorMessage>{errors.teamLead_Id?.message}</FormErrorMessage>
                            </FormControl>

                        </Grid>
                        <Flex justify="flex-end" mt={6} gap={4}>
                            <CustomButton type="button" title="Send & Verify" onClick={handleSubmit((data) => onSubmit(data, false))} className="btn font-poppins text_sm text_medium btn_theme" isLoading={verifyLoading} />
                            {hasPermission("OffersOnBording", "sendOfferLetter") && (
                                <CustomButton type="button" title="Verify & Send Offer Letter" onClick={handleSubmit((data) => onSubmit(data, true))} className="btn font-poppins text_sm text_medium btn_theme" isLoading={verifyLoading} />
                            )}
                        </Flex>
                    </ModalBody>
                </ModalContent>
            </Modal>

            {/*------------------------------------------------------- sent back modal ---------------------------------------------------  */}
            <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} size="5xl" isCentered>
                <ModalOverlay />
                <ModalContent p={1} borderRadius="xl" as="form" onSubmit={sendCandidateEmail}>
                    <ModalHeader textAlign="center" className="font-poppins text_medium text_xl">
                        {modalMode === "sendBack" ? "Send Back to Candidate" : "Request Additional Documents"}
                    </ModalHeader>
                    <ModalCloseButton />
                    <Divider />
                    <ModalBody>
                        <FormControl mb={4} isRequired>
                            <FormLabel>Subject</FormLabel>
                            <Input value={subject} onChange={(e) => setSubject(e.target.value)} />
                        </FormControl>

                        <FormControl mb={4} isRequired>
                            <FormLabel>Email Body</FormLabel>
                            <SunEditor getSunEditorInstance={(editor) => (editorRef.current = editor)} height="200px" setContents={emailBody} onChange={(content: string) => setEmailBody(content)} />
                        </FormControl>

                        <Flex justify="center" mt={6}>
                            <CustomButton type="submit" title={modalMode === "sendBack" ? "Send Email" : "Send Request"} className="btn font-poppins text_sm text_medium btn_theme" isLoading={sendEmailLoading} />
                        </Flex>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </MyDiv>
    );
};

export default ApproveAllCard;
